import React, {createContext, useContext, useEffect, useState} from "react";
import axios from "axios";
import {Basket, EditProduct, Product} from "./uc/domain.ts"
import {createBasketAPI, loadBasketFromAPIByID} from "./uc/services.ts";
import {deleteBasketIDFromLS, loadBasketIDFromLS, saveBasketIDToLS} from "./uc/storage.ts";
import {getClientUID} from "./helpers.ts";
import useSalepoints from "./useSalepoints.ts";

interface BasketContextType {
    products: Product[],
    currentEditProduct: EditProduct | null,
    setCurrentEditProduct: (productRef: string | null, qty:number) => Promise<void>
    newBasket(salePoint: string, product: Product[]),
    deleteBasket(),
    basket: Basket | null,
    total: number,
}

export const BasketContext = createContext<BasketContextType | null>(null)

export function BasketProvider({children}: { children: React.ReactNode }) {
    const ownerID = getClientUID()
    const [basket, setBasket] = useState<Basket | null>(null)
    const {favoriteShop} = useSalepoints()
    // Загрузка корзины при инициализации (если нужно)
    useEffect(() => {
        const bID = loadBasketIDFromLS()
        if (bID && favoriteShop) {
            loadBasketFromAPIByID(bID, ownerID, favoriteShop.sanremoRef).then(receivedBasket => {
                console.log('receivedBasket')
                console.log(receivedBasket)
                setBasket(receivedBasket)
                if (receivedBasket.products) {
                    setProductsState(receivedBasket.products)
                }
            })
        }
        // [] or favoriteShop - 2 if need load after shop selected
    }, []);

    function newBasket(salePoint: string, product: Product[]) {
        createBasketAPI(ownerID, salePoint, product).then(basket => {
            changeBasket(basket)
        })
    }
    const deleteBasket = () => {
        deleteBasketIDFromLS()
        setBasket(null)
    }
    const changeBasket = (basket: Basket) => {
        if (basket.id) {
            saveBasketIDToLS(basket.id)
            setBasket(basket)
        }
    }
    const [products, setProductsState] = useState<Array<Product>>([])
    const [currentEditProduct, setCurrentEditProductState] = useState<null | EditProduct>(null)
    const [total, setTotal] = useState(0)

    const setCurrentEditProduct = async (productRef: string | null, qty = 1): Promise<void> => {
        // cancel edit
        if (productRef === null) {
            setCurrentEditProductState(null)
            return
        }
        // new one
        if (currentEditProduct === null || currentEditProduct.product.id !== productRef || currentEditProduct.stockPrice === undefined) {
            const result = await axios.get(`/sku/${productRef}`)
            result.data.product.quantity = qty
            setCurrentEditProductState({product: result.data.product, stockPrice: result.data.stock, finalAction:false})
            return
        }
        // modify
        setCurrentEditProductState((prev) => {
            if (prev === null) {
                console.warn('unexpected modify with previous null')
                return null
            }
            const product= {...prev.product, quantity: qty}
            return {product, stockPrice: prev.stockPrice, finalAction:true}
        })
    }
    const updateProducts = () => {
        if (currentEditProduct === null) {
            return;
        }
        setProductsState((prevProducts): Product[] => {
            let patchedProducts = []
            // zero qty -> delete from products
            if (currentEditProduct.product.quantity <= 0) {
                return prevProducts.filter(el => {
                    return el.id != currentEditProduct.product.id
                })
            }
            const alreadyHas = prevProducts.find(el => el.id === currentEditProduct.product.id)
            if (alreadyHas) {
                patchedProducts = prevProducts.map(el => el.id === currentEditProduct.product.id ? {
                    ...el,
                    quantity: currentEditProduct.product.quantity
                } : el)
                return patchedProducts
            } else {
                if (currentEditProduct) {
                    const newProduct: Product = {...currentEditProduct.product, quantity: currentEditProduct.product.quantity}
                    return [...prevProducts, newProduct]
                }
            }
        })
        setCurrentEditProductState(null)
        return;
    }
    const onBasketLoad = (basketProducts: Product[]) => {
        setProductsState(basketProducts)
    }
    useEffect(() => {
        const t = products.reduce(((accum, currentValue) => {
            accum += (currentValue.quantity || 1) * currentValue.price
            return accum
        }), 0)
        setTotal(t)
    }, [products])

    useEffect(() => {
        if (currentEditProduct === null || !currentEditProduct.finalAction) {
            return
        }
       updateProducts()
    }, [currentEditProduct]);
    return <BasketContext.Provider value={{
        currentEditProduct,
        setCurrentEditProduct,
        products, basket, newBasket,
        total, deleteBasket
    }}>
        {children}
    </BasketContext.Provider>
}



